import { format } from "date-fns";
import { v5, NIL } from "uuid";
const foldTextIfNeededAccordingToICSSpec = (text, numOfChars = 74) => {
  const regex = new RegExp(`(.{${numOfChars}})`, "g");
  return text.replace(regex, "$1\n ");
};
const convertToCRLFLineEndings = (text) => text.replace(/\n/g, "\r\n");
const generateIcsEvent = ({
  title,
  description,
  location,
  start,
  end,
  lat,
  lon,
  name,
  email,
  id
}) => {
  return convertToCRLFLineEndings(`BEGIN:VCALENDAR
VERSION:2.0
CALSCALE:GREGORIAN
PRODID:grandvision/appointment
METHOD:PUBLISH
X-PUBLISHED-TTL:PT1H
BEGIN:VEVENT
UID:${v5(`${id}-${start}`, NIL)}
${foldTextIfNeededAccordingToICSSpec(`SUMMARY:${title}`)}
DTSTAMP:${format(/* @__PURE__ */ new Date(), `yyyyMMdd'T'HHmmss`)}
DTSTART:${format(start, `yyyyMMdd'T'HHmmss`)}
DTEND:${format(end, `yyyyMMdd'T'HHmmss`)}
SEQUENCE:1
${foldTextIfNeededAccordingToICSSpec(`DESCRIPTION:${description}`)}${/* don't put a newline if GEO coords not available */
  lat && lon ? `
GEO:${lat};${lon}` : ``}
${foldTextIfNeededAccordingToICSSpec(`LOCATION:${location}`)}
STATUS:CONFIRMED
${foldTextIfNeededAccordingToICSSpec(`ORGANIZER;CN=${name}:mailto:${email ? `${email}` : ``}`)}
BEGIN:VALARM
ACTION:DISPLAY
${foldTextIfNeededAccordingToICSSpec(`DESCRIPTION:Reminder: ${description}`, 74)}
TRIGGER:-PT2H
END:VALARM
END:VEVENT
END:VCALENDAR
`);
};
const generateIcsBlob = (icsEvent) => new Blob([icsEvent], { type: "text/calendar" });
const generateIcsUrl = (icsBlob) => URL.createObjectURL(icsBlob);
export {
  foldTextIfNeededAccordingToICSSpec,
  generateIcsBlob,
  generateIcsEvent,
  generateIcsUrl
};
//# sourceMappingURL=ics-url-generator.js.map
